import { useUserStore } from './useUserStore';

export function useUserEmail() {
	const userStore = useUserStore();

	return userStore.user?.email;
}
